<template>
<div>
    <!-- 图文列表 -->
  <div class="cardMain" v-if="limit == 9">
    <div class="tabsPart9">
      <div style="display:flex;">
        <div v-for="(ttitem, ttindex) in dataList" class="tabsItem" :class="currentIndex == ttindex ? 'active' : ''" :key="ttindex" @click="toList(ttitem)" @mouseover="chooseTab(ttindex)">{{ttitem.title =='评优评先'? '通知公告': ttitem.title}}</div>
      </div>
      <div>
        <div class="apply" @click="downDoc">申请入会</div>
      </div>
    </div>
    <div
      v-for="(item, index) in dataList"
      :key="index" 
      v-if="currentIndex == index"
    >
      <div v-for="(tItem, tIndex) in item.list" :key="tIndex" class="listcss" style="margin: 6px 0 0px;" @click="judgmentTurn(tItem)">
        <div class="listcss">
          <div class="square"></div>
          <div class="listcssTitle">{{ tItem.title }}</div>
        </div>
        <div class="listcssDate">[{{ tItem.createTime.slice(0,10) }}]</div>
      </div>
    </div>
  </div>
  <div class="cardMain" v-else>
    <div class="tabsPart">
      <div>
        <div v-for="(ttitem, ttindex) in dataList" class="tabsItem" :class="currentIndex == ttindex ? 'active' : ''" :key="ttindex" @click="toList(ttitem)" @mouseover="chooseTab(ttindex)">{{ttitem.title =='法律法规'? '规章规范': ttitem.title}}</div>
      </div>
      <div>
        <div @click="toList(dataList[currentIndex])">更多>></div>
      </div>
    </div>
    <div
      v-for="(item, index) in dataList"
      :key="index" 
      v-if="currentIndex == index"
    >
      <div v-for="(tItem, tIndex) in item.list" :key="tIndex" class="listcss" style="margin: 6px 0 0px;" @click="judgmentTurn(tItem)">
        <div class="listcss">
          <div class="square"></div>
          <div class="listcssTitle">{{ tItem.title }}</div>
        </div>
        <div class="listcssDate">[{{ tItem.createTime.slice(0,10) }}]</div>
      </div>
    </div>
  </div>
</div>
  
</template>

<script>
export default {
  name: "Footer",
  props: {
    limit: Number,
    cardType: String,
    Data: Array,
  },
  methods: {
    handleClick() {
      console.log("123");
    },
    chooseTab(index){
        this.currentIndex = index
    },
    toList(item){
      this.$router.push(`/committee/Content?type=${item.title}&typeId=${item.typeId}`)
      
    },
    downDoc(){
      this.$router.push(`/committee/Content?type=首页图片&typeId=2c9151b47f44d407017f6e1e46a50014&articleId=4028b8817f2b21ab017f2b2c0a880000`)
      // window.open('https://carec.oss-cn-beijing.aliyuncs.com/upload/2022/02/24/0c18d88f-0285-4e31-9ddf-ae412b528b01.doc')
    },
    needHide(){
      //获取文本的行高，并获取文本的高度，假设我们规定的行数是五行，那么对超过行数的部分进行限制高度，并加上省略号
      var pic = document.getElementById("pic")
      if(pic){
        if(pic.clientHeight>57){
          pic.classList.add("p-after")
          pic.style.height = '57px'
        } else {
          pic.classList.remove("p-after")
          pic.style.height = 'auto'
        }
      }
      
    },
    toDetail(item){
      var routeData =  this.$router.resolve({
        path: `/committee/Content`,
        query: {
          type:this.dataList[this.currentIndex].title,
          typeId:this.dataList[this.currentIndex].typeId,
          articleId: item.id
        },
      });
      window.open(routeData.href, '_blank');
    },
    downloadView(item){
      window.open(item.url)
    },
    judgmentTurn(item){
      if(item.imageUrl){
        this.downloadView(item)
      } else {
        this.toDetail(item)
      }
    }
  },
  mounted() {
    var data = JSON.parse(JSON.stringify(this.Data));
    this.dataList = data;

    
    setTimeout(() => {
      this.needHide()
    }, 100);
   
  },
  created(){
    
  },
  data() {
    return {
      currentIndex: 0,
      dataList: []
    };
  },
};
</script>

<style>
.cardMain {
  width: 590px;
  padding: 0;
  background: #fff;
}
.cardMain .tabsPart{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dcdcdc;
}
.cardMain .tabsPart .tabsItem{
    width: 100px;
    cursor: pointer;
    font-size: 20px;
    text-align: center;
    border-bottom: 2px solid #fff;
    line-height: 40px;
}
.cardMain .tabsPart .active{
    font-weight: bold;
    color: #29599c;
    border-bottom: 2px solid #29599c;
}
.cardMain .tabsPart9{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dcdcdc;
}
.cardMain .tabsPart9 .apply{
  cursor: pointer;
  width: 100px;
  height: 40px;
  text-align: center;
  font-size: 16px;
  background: #ffa200;
  margin-bottom: -2px;
  color: #fff;
  line-height: 40px;
}
.cardMain .tabsPart9 .tabsItem{
    width: 120px;
    cursor: pointer;
    font-size: 20px;
    text-align: center;
    background: #fff;
    border-bottom: 2px solid #fff;
    line-height: 40px;
}
.cardMain .tabsPart9 .active{
    font-weight: bold;
    color: #fff;
    border-bottom: 2px solid #29599c;
    background: #29599c;
}
.cardMain .el-tabs__header {
  margin: 0 0 5px;
}
.cardMain .el-tabs__nav .el-tabs__item {
  font-size: 16px;
  width: 131px;
  height: 45px;
  line-height: 45px;
  padding: 0 !important;
  text-align: center;
}
.cardMain .el-tabs__nav .el-tabs__item.is-active {
  font-weight: bold;
  font-size: 18px;
  color: #3e69b9;
}
.cardMain .el-tabs__nav .el-tabs__active-bar {
  background: #3e69b9;
  height: 3px;
}
.cardMain .listcss {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cardMain .square {
  height: 4px;
  width: 4px;
  margin: 8px 8px 8px 0;
  border-radius: 50%;
  background: #094895;
}
.cardMain .listcssTitle {
  height: 28px;
  line-height: 28px;
  width: 440px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 16px;
}
.cardMain .listcssTitle:hover {
  text-decoration-line: underline;
  cursor: pointer;
}
.cardMain .listcssDate {
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  color: #000;
}
.cardMain .imgLine {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cardMain .imgLine .imgPart {
  width: 180px;
  height: 120px;
  background: skyblue;
  overflow: hidden;
  margin: 15px 0 10px;
}
@keyframes mymove{
    0%{
    transform: scale(1);  /*开始为原始大小*/
    }
    100%{
        transform: scale(1.3); /*放大1.1倍*/
    }
}
.cardMain .imgLine .imgPart img:hover {
  animation-name: mymove;    
      animation-direction: alternate;  
      animation-timing-function: linear;   
      animation-duration: 0.5s;
      animation-fill-mode : forwards ;
      -webkit-animation-fill-mode : forwards ;
}
.cardMain .imgLine .textPart {
  width: 357px;
}

.cardMain .imgLine .textPart .content {
  font-size: 14px;
  line-height: 19px;
  max-height: 57px;
  text-indent: 2em;
  overflow: hidden;
}
.p-after:after{
    content: "..."; 
    position: absolute; 
    bottom: 0; 
    right: 0; 
    padding-left: 40px;
    background: -webkit-linear-gradient(left, transparent, #fff 55%);
    background: -moz-linear-gradient(left, transparent, #fff 55%);
    background: -o-linear-gradient(left, transparent, #fff 55%);
    background: linear-gradient(to right, transparent, #fff 55%);
}
.cardMain .imgLine .textPart .title {
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  line-height: 30px;
  font-size: 19px;
}
.cardMain .imgLine .textPart .title:hover {
  cursor: pointer;
  text-decoration:underline;
}

.magazine {
  width: 400px;
}

.magazine .header {
  display: flex;
  align-items: center;
  margin: 6px 0 12px;
  justify-content: space-between;
}
.magazine .titleLine {
  width: 100%;
  height: 2px;
  
  background: #e4e7ed;
}
.magazine .header .rightPart {
    cursor: pointer;
  width: 60px;
  font-size: 15px;
  color: #999;
  text-align: right;
}
.magazine .header .leftPart {
  display: flex;
  align-items: center;
  width: 180px;
}
.magazine .header .leftPart .text {
  font-size: 18px;
  margin-left: 10px;
}
.magazine .magazineList {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.magazine .magazineList .magazineItem {
  text-align: center;
  cursor: pointer;
  margin: 13px 15px 1px;
}
.magazine .magazineList .magazineItem .itemImg {
  width: 150px;
  height: 210px;
}
.magazine .magazineList .magazineItem .itemTitle {
  font-size: 16px;
  color: #551a8b;
}

@keyframes rowup {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(0, -4898px, 0);
    transform: translate3d(0, -4898px, 0);
    display: none;
  }
}
.cardMain .unitList {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-around;
  -webkit-animation: 400s rowup linear infinite normal;
  animation: 400s rowup linear infinite normal;
  flex-wrap: wrap;
}
.cardMain .unitList .unitItem {
  width: 320px;
  height: 40px;
  line-height: 40px;
  margin: 11px 0;
  background: #f8f8f8;
  display: flex;
  align-items: center;
}
.cardMain .unitList .unitItem .unitSquare {
  width: 5px;
  height: 5px;
  margin: 0 20px;
  border: 3px solid #285cac;
}
.cardMain .unitList .unitItem .unitTitle {
  color: #555555;
  font-weight: bold;
  font-size: 16px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
.cardMain .unitList .unitItem .unitTitle:hover {
  text-decoration-line: underline;
  cursor: pointer;
}
</style>
